import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { DisponibilidadeTeleOrientacao } from "../interfaces/entities/DisponibilidadeTeleOrientacao";
import { ParametrosIngressarReuniao } from "../interfaces/entities/ParametrosIngressarReuniao";

export const ingressarReuniao = async (idReuniao: string): Promise<ParametrosIngressarReuniao | null> => {
    try {
        const response = await apiClientes.post('/Agenda/IngressarReuniao', {
            idReuniao: idReuniao
        }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};

export const getHabilitaValidacaoTelemedicina = async (): Promise<string | null> => {
    try {
        const response = await apiClientes.get('/Config/GetHabilitaValidacaoTelemedicina', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
        return response.data;
      } catch (error: any) {
        console.log({ error });
        return error.response;
      }
}

export const getDisponibilidadeTeleOrientacao = async (): Promise<DisponibilidadeTeleOrientacao | null> => {
    try {
        const response = await apiClientes.get('/Config/DisponibilidadeTeleOrientacao', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
        return response.data;
      } catch (error: any) {
        console.log({ error });
        return error.response;
      }
}